import { useContext } from 'react';
import { Formik } from 'formik';
import { CircleLoader } from 'components';
import CountryForm from './components';
import { countryContext, countrySchema } from './CountryDetailsContext';

let CountryDetails = () => {

    let service = useContext(countryContext);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={service.country}
            validationSchema={countrySchema}
            onSubmit={(values, action) => {
                service.saveCountry(values);
                action.setSubmitting(false);;
            }}
        >
            <>
                {service.isLoading && <CircleLoader />}
                {service.isLoading === false && <CountryForm />}
            </>
        </Formik>
    )
}

export default CountryDetails;